import React from "react";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { Navigate, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import RootLayout from "./components/Layout/RootLayout";
import Loading from "./components/Utils/Loading";
import ErrorPage from "./components/Pages/Error";

const Assets = React.lazy(() => import("./components/Pages/Assets"));
const Allocation = React.lazy(() => import("./components/Pages/Allocation"));
const Users = React.lazy(() => import("./components/Pages/Users"));
const AssetMonitoringSwitch = React.lazy(
  () => import("./components/Assets/MonitoringSwitch")
);
const AllocationMonitoringSwitch = React.lazy(
  () => import("./components/Allocation/MonitoringSwitch")
);
const WellTestHistory = React.lazy(
  () => import("./components/Allocation/WellTestHistory")
);

const App = () => {
  return (
    <div className="App">
      <Provider store={store}>
        <React.Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/" element={<RootLayout />}>
              <Route index element={<Navigate to="assets" />} />
              <Route path="assets" element={<Assets />}>
                <Route index element={""} />
                <Route path=":level/:id" element={<AssetMonitoringSwitch />} />
              </Route>
              <Route path="allocation" element={<Allocation />}>
                <Route index element={""} />
                <Route path=":level/:id" element={<AllocationMonitoringSwitch />} />
                <Route path=":level/:id/well-test-history" element={<WellTestHistory />} />
              </Route>
              <Route path="users" element={<Users />} />
              <Route path="*" element={<ErrorPage />} />
            </Route>
          </Routes>
        </React.Suspense>
      </Provider>
    </div>
  );
};

export default App;
